<template>
  <vs-row>
    <vs-col
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="5"
      vs-md="4"
      vs-sm="12"
    >
      <div
        class="mr-8"
        :style="{
          'background-image': 'url(/imagen-inscripcion.jpg)',
          width: '100%',
          height: '100%',
          'border-radius': '5px',
          'background-position-x': 'center',
          'background-position-y': 'bottom',
          'background-size': 'cover',
        }"
      ></div>
    </vs-col>
    <vs-col
      vs-justify="center"
      vs-align="center"
      vs-lg="7"
      vs-md="8"
      vs-sm="12"
    >
      <vs-row vs-type="flex" vs-justify="center" class="mb-4">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <h1 class="">Registro</h1>
        </vs-col>
      </vs-row>

      <!-- tab 1 content -->
      <div class="vx-row">
        <vs-divider color="#197CBF"></vs-divider>
        <vs-row vs-justify="center">
          <vs-col vs-type="flex" vs-justify="left">
            <h5 class="">Datos Personales</h5>
          </vs-col>
        </vs-row>
        <!-- First Name -->
        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="Nombre *"
            color="#197CBF"
            name="firstName"
            v-model="firstName"
            class="w-full"
            placeholder="Nombre"
          />
          <span class="text-danger text-sm" v-if="$v.firstName.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="Primer Apellido *"
            color="#197CBF"
            name="surName1"
            v-model="surName1"
            class="w-full"
            placeholder="Primer Apellido"
          />
          <span class="text-danger text-sm" v-if="$v.surName1.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="Segundo Apellido *"
            color="#197CBF"
            name="fistName"
            v-model="surName2"
            class="w-full"
            placeholder="Segundo Apellido"
          />
          <span class="text-danger text-sm" v-if="$v.surName2.$error">
            {{ requiredErrorMessage }}
          </span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <label class="vs-input--label">Nacionalidad *</label>
          <v-select
            v-model="nationality"
            :options="nationalitiesOptions"
            label="label"
            :clearable="false"
            :searchable="true"
          >
            <!--  :reduce="(option) => option.value"-->
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>
          <span class="text-danger text-sm" v-if="$v.nationality.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <label class="vs-input--label">Fecha nacimiento *</label>
          <datepicker
            :language="languages[language]"
            format="dd/MM/yyyy"
            v-model="birthDate"
            :disabled-dates="toDisabledDates"
          ></datepicker>

          <span class="text-danger text-sm" v-if="$v.birthDate.$error">
            <div v-if="!$v.birthDate.required">
              {{ requiredErrorMessage }}
            </div>
            <div v-else-if="!$v.birthDate.validateYears">
              {{ signDocumentErrorMessage }}
            </div>
          </span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <label class="vs-input--label">Sexo</label>
          <v-select
            v-model="gender"
            :options="genderOptions"
            :reduce="(sexOption) => sexOption.value"
            label="label"
            :clearable="false"
            :searchable="false"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>
          <span class="text-danger text-sm" v-if="$v.gender.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <label class="vs-input--label">Estado Civil</label>
          <v-select
            v-model="martialStatus"
            :options="martialStusOptions"
            :reduce="(sexOption) => sexOption.value"
            label="label"
            :clearable="false"
            :searchable="false"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>
          <span class="text-danger text-sm" v-if="$v.martialStatus.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="E-mail *"
            color="#197CBF"
            name="email"
            v-model="email"
            class="w-full"
            placeholder="E-mail"
          />
          <span class="text-danger text-sm" v-if="$v.email.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="DPI *"
            color="#197CBF"
            name="idDocument"
            v-model="idDocument"
            class="w-full"
            maxlength="13"
            placeholder="DPI"
          />
          <span class="text-danger text-sm" v-if="$v.idDocument.$error">
            <div v-if="!$v.idDocument.required">
              {{ requiredErrorMessage }}
            </div>
            <div v-else-if="!$v.idDocument.validateDPI">
              {{ invalidDocumentIdErrorMessage }}
            </div>
          </span>
          <span
            class="text-danger text-sm"
            v-else-if="showIdDocumentIsUniqueError"
          >
            <div>
              {{ existDocumentIdErrorMessage }}
            </div>
          </span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="Móvil *"
            color="#197CBF"
            name="mobile"
            v-model="mobile"
            class="w-full"
            maxlength="8"
            placeholder="Móvil"
          />
          <span class="text-danger text-sm" v-if="$v.mobile.$error"
            ><div v-if="!$v.idDocument.required">
              {{ requiredErrorMessage }}
            </div>
            <div v-else-if="!$v.idDocument.validatePhone">
              {{ invalidPhoneErrorMessage }}
            </div></span
          >
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <label class="vs-input--label">¿Cómo nos ha conocido? *</label>
          <v-select
            v-model="knowUs"
            :options="knowUsOptions"
            :reduce="(knowUsOption) => knowUsOption.value"
            label="label"
            :clearable="false"
            :searchable="false"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>
          <span class="text-danger text-sm" v-if="$v.knowUs.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <vs-divider color="#197CBF"></vs-divider>
        <vs-row vs-justify="center">
          <vs-col vs-type="flex" vs-justify="left">
            <h5 class="">Direccion</h5>
          </vs-col>
        </vs-row>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="Dirección *"
            color="#197CBF"
            name="address"
            v-model="address"
            class="w-full"
            placeholder="Dirección"
          />
          <span class="text-danger text-sm" v-if="$v.address.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="Dirección particular"
            color="#197CBF"
            name="address"
            v-model="referenceAddress"
            class="w-full"
            placeholder="Dirección particular"
          />
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <label class="vs-input--label">Departamento *</label>
          <v-select
            v-model="state"
            :options="stateOptions"
            :reduce="(stateOption) => stateOption.title"
            label="title"
            :clearable="false"
            :searchable="true"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>
          <span class="text-danger text-sm" v-if="$v.state.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
          <label class="vs-input--label">Municipio *</label>
          <v-select
            v-model="city"
            :options="cityOptions"
            :clearable="false"
            :searchable="true"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>

          <span class="text-danger text-sm" v-if="$v.city.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="Codigo Postal"
            color="#197CBF"
            name="zipCode"
            v-model="zipCode"
            class="w-full"
            placeholder="Codigo Postal"
          />
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5" v-if="requiredZone">
          <label class="vs-input--label">Zona *</label>
          <v-select
            v-model="zone"
            :options="zoneOptions"
            :clearable="false"
            :searchable="false"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>

          <span class="text-danger text-sm" v-if="$v.zone.$error">{{
            requiredErrorMessage
          }}</span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <vs-divider color="#197CBF"></vs-divider>
        <vs-row vs-justify="center">
          <vs-col vs-type="flex" vs-justify="left">
            <h5 class="">Sede</h5>
          </vs-col>
        </vs-row>
        <div class="vx-col w-full mt-5">
          <label class="vs-input--label">
            Selecciona el centro que será asignado
          </label>
          <v-select
            v-model="location"
            :options="locationOptions"
            :reduce="(locationOption) => locationOption._id"
            label="nombre"
            :disabled="preSaleMode"
            :clearable="false"
            :searchable="!preSaleMode"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>
          <span class="text-danger text-sm" v-if="$v.location.$error">
            {{ requiredErrorMessage }}
          </span>
          <!--          <span class="text-danger text-sm" v-else>&nbsp;</span>-->
        </div>

        <div class="vx-col w-full mt-5">
          <ul class="centerx">
            <li class="flex">
              <vs-checkbox
                color="#197CBF"
                v-model="checkBox3"
                :disabled="isEmptyRequiredProperties"
              >
                <div>
                  {{ message4 }}
                </div>
              </vs-checkbox>
            </li>
            <li>
              <span class="text-danger text-sm" v-if="$v.checkBox3.$error">
                {{ requiredErrorMessage }}
              </span>
            </li>
            <li>
              <span
                class="text-primary text-sm opacity-75"
                v-if="isEmptyRequiredProperties"
              >
                Para aceptar los términos y condiciones, por favor complete
                todos los campos requeridos (*)
              </span>
            </li>
          </ul>
        </div>
      </div>
    </vs-col>
    <modal name="modal-terms" height="90%" width="90%" :click-to-close="false">
      <slot name="top-right" style="height: 10%">
        <div class="text-right">
          <vs-button
            class="vs-con-loading__container"
            type="border"
            @click="cancelTermsAndConditions"
            size="small"
          >
            X
          </vs-button>
        </div>
      </slot>
      <vs-alert color="primary" :active="!loadedTermsAndConditions">
        <span> Cargando documento... </span>
      </vs-alert>
      <object
        :data="termsAndConditionsLink"
        type="application/html"
        width="100%"
        height="90%"
      >
        <iframe
          :src="termsAndConditionsLink"
          width="100%"
          height="90%"
          title="Contract"
          @load="completeLoading"
        >
          <p>
            Your browser does not support.
            <a :href="termsAndConditionsLink">View the contract</a>.
          </p>
        </iframe>
      </object>
    </modal>
  </vs-row>
</template>

<script>
import genderConstant from "@/constants/gender.constant";
import martialStatusOptions from "@/constants/martialStatusOptions.constant";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import knowUsConstant from "@/constants/knowUs.constant";
import messageError from "@/constants/messageError.constants";
import messages from "@/constants/message.constant";
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import guatemalaZonesConstants from "@/constants/guatemalaZones.constants";
import moment from "moment-timezone";
import utils from "./utils";
import { nationalitiesOptions } from "@/constants/nationalitiesCode.constants.js";

// import Modal from "vue-js-modal";
const validateDPI = (value) => value.length == 13 && /^\d+$/.test(value);
const validatePhone = (value) => value.length == 8 && /^\d+$/.test(value);

const validateYears = (value) => {
  const dateNow = moment().tz("America/Guatemala");
  const birthDate = moment(value).tz("America/Guatemala");
  const years = Math.abs(birthDate.diff(dateNow, "years"));
  return years >= 18;
};
export default {
  name: "first-step",
  props: {
    stateOptions: {
      type: Array,
      default: () => [],
    },
    preSaleMode: {
      type: Boolean,
      default: false,
    },
    preSaleLocationNumber: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    Datepicker,
  },

  computed: {
    birthDateFormat() {
      return moment(this.birthDate).format("DD-MM-YYYY");
    },
    termsAndConditionsLink() {
      return `https://tools.mayfer.software/contrato-imp?nombre-completo=${this.firstName}%20${this.surName1}%20${this.surName2}&fecha-nacimiento=${this.birthDateFormat}&nacionalidad=${this.nationality.label}&fecha-alta=08-11-2023&state=${this.state}&dpi=${this.idDocument}`;
    },
    isEmptyRequiredProperties() {
      if (
        this.firstName == "" ||
        this.surName1 == "" ||
        this.surName2 == "" ||
        this.birthDate == "" ||
        this.state == "" ||
        this.idDocument == "" ||
        this.nationality == ""
      ) {
        return true;
      }

      return false;
    },
  },
  emits: ["on-validated", "requestPackages"],
  data() {
    return {
      cityOptions: [],
      zoneOptions: guatemalaZonesConstants,

      genderOptions: genderConstant,
      martialStusOptions: martialStatusOptions,
      knowUsOptions: knowUsConstant,
      locationOptions: [],
      language: "es",
      languages: lang,

      firstName: "",
      surName1: "",
      surName2: "",
      nationality: "",
      gender: "",
      martialStatus: "",
      // birthDate: '',
      birthDate: moment().subtract(18, "years").format("YYYY-MM-DD"),
      email: "",
      idDocument: "",
      mobile: "",
      knowUs: "",
      address: "",
      location: "",
      checkBox1: false,
      checkBox2: false,
      checkBox3: false,

      requiredZone: false,
      referenceAddress: "",
      city: "",
      state: "",
      zone: "",
      zipCode: "",

      model: {
        customer_details: {
          name: "",
          surname: "",
          surname_1: "",
          surname_2: "",
          birth_date: "",
          document_type: "es_dni",
          id_document: "",
          gender: "",
          language: "0",
          nationality: "",
          marital_status: 1,
          phone: "12345678",
          mobile: "",
          email: "",
          profession: "Student",
          center: "1",
          salesman_1: "12",
          salesman_2: "5",
          address: {
            address: "",
            number: "",
            staircase: "B",
            floor: "2",
            door: "3",
            postal_code: "",
            settlement: "settlement",
            neighbourhood: "neighbourhood",
            town: "",
            province: "",
            country: "Guatemala",
          },
        },
      },
      requiredErrorMessage: messageError.REQUIRED_ERROR_MESSAGE,
      signDocumentErrorMessage: messageError.SIGN_DOCUMENT,
      invalidDocumentIdErrorMessage: messageError.INVALID_DOCUMENT_ID,
      existDocumentIdErrorMessage: messageError.EXIST_DOCUMENT_ID,
      invalidPhoneErrorMessage: messageError.INVALID_PHONE,
      message1: messages.MESSAGE_1,
      message2: messages.MESSAGE_2,
      message3: messages.MESSAGE_3,
      message4: messages.MESSAGE_4,
      idDocumentIsUnique: false,
      showIdDocumentIsUniqueError: false,

      loadedTermsAndConditions: false,
      toDisabledDates: {
        from: new Date(moment().subtract(18, "years").format("YYYY-MM-DD")),
      },
      nationalitiesOptions: nationalitiesOptions,
    };
  },
  validations() {
    if (this.requiredZone) {
      return {
        firstName: {
          required,
        },
        surName1: {
          required,
        },
        surName2: {
          required,
        },
        nationality: {
          required,
        },
        gender: {
          required,
        },
        martialStatus: {
          required,
        },
        birthDate: {
          required,
          validateYears,
        },
        email: {
          required,
        },
        idDocument: {
          required,
          validateDPI,
        },
        mobile: {
          required,
          validatePhone,
        },
        knowUs: {
          required,
        },
        address: {
          required,
        },
        checkBox3: {
          isTrue(value) {
            return value;
          },
        },
        location: {
          required,
        },
        zone: {
          required,
        },
        city: {
          required,
        },
        state: {
          required,
        },
      };
    } else {
      return {
        firstName: {
          required,
        },
        surName1: {
          required,
        },
        surName2: {
          required,
        },
        nationality: {
          required,
        },
        gender: {
          required,
        },
        martialStatus: {
          required,
        },
        birthDate: {
          required,
          validateYears,
        },
        email: {
          required,
        },
        idDocument: {
          required,
          validateDPI,
        },
        mobile: {
          required,
          validatePhone,
        },
        knowUs: {
          required,
        },
        address: {
          required,
        },
        checkBox3: {
          isTrue(value) {
            return value;
          },
        },
        location: {
          required,
        },
        city: {
          required,
        },
        state: {
          required,
        },
      };
    }
  },
  methods: {
    redirectPreSaleLocationNotFound() {
      this.$router.push({
        name: "error",
        query: {
          MESSAGE: btoa(
            "No se encontró la sede en preventa solicitada. Verifique el enlace e intente nuevamente."
          ),
        },
      });
    },

    buildGetSedesPayload() {
      if (!this.preSaleMode || !this.preSaleLocationNumber) {
        return {};
      }

      const bodyFormData = new FormData();
      bodyFormData.append("sedes", this.preSaleLocationNumber);
      return bodyFormData;
    },

    completeLoading() {
      this.loadedTermsAndConditions = true;
    },

    cancelTermsAndConditions() {
      this.loadedTermsAndConditions = false;
      this.checkBox3 = false;
      this.$modal.hide("modal-terms");
    },

    async validate() {
      this.$v.$touch();

      if (!this.$v.$error) {
        utils.nextStep();

        this.$vs.loading({
          background: "rgba(25, 124, 191, 0.7)",
          color: "#FFFFFF",
          container: "#vx-loading",
          type: "sound",
          scale: 0.45,
        });

        await this.validateIdDocument();
        if (this.idDocumentIsUnique) {
          this.model.customer_details.name = this.firstName.trim();
          this.model.customer_details.surname =
            `${this.surName1.trim()} ${this.surName2.trim()}`.trim();
          this.model.customer_details.surname_1 = this.surName1.trim();
          this.model.customer_details.surname_2 = this.surName2.trim();
          this.model.customer_details.nationality = this.nationality.label;
          this.model.customer_details.nationality_code = this.nationality.value;
          this.model.customer_details.birth_date = moment(
            this.birthDate
          ).format("YYYY-MM-DD");
          this.model.customer_details.id_document = this.idDocument;
          this.model.customer_details.gender = this.gender;
          this.model.customer_details.marital_status = this.martialStatus;
          this.model.customer_details.mobile = this.mobile;
          this.model.customer_details.email = this.email.trim();
          this.model.customer_details.center = +this.locationOptions.find(
            (element) => element._id == this.location
          ).codigo;
          this.model.customer_details.address.address = this.address;
          this.model.customer_details.address.number = this.referenceAddress;
          this.model.customer_details.address.postal_code = this.zipCode;
          this.model.customer_details.address.province = this.state;
          this.model.customer_details.address.town = this.city;
          this.model.customer_details.address.neighbourhood = this.zone.value;
          this.$emit("on-validated", this.model);
          utils.nextStep();
          this.$vs.loading.close("#vx-loading > .con-vs-loading");
          return true;
        } else {
          this.$vs.loading.close("#vx-loading > .con-vs-loading");
          utils.nextStep();
        }
      } else {
        this.$vs.loading.close("#vx-loading > .con-vs-loading");
        utils.nextStep();
        return false;
      }
    },
    async validateIdDocument() {
      const bodyFormData = new FormData();
      bodyFormData.append("dpi", this.idDocument);
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${process.env.VUE_APP_API_URL}/api/1.1/wf/dpi-check`,
            bodyFormData,
            {
              headers: {
                Authorization: `Bearer ${process.env.VUE_APP_TOKEN}`,
              },
            }
          )
          .then((response) => {
            this.showIdDocumentIsUniqueError = false;
            this.idDocumentIsUnique = true;
            if (response.data.response.error) {
              this.idDocumentIsUnique = false;
              this.showIdDocumentIsUniqueError = true;
            }
            resolve(this.idDocumentIsUnique);
          })
          .catch(() => {
            this.idDocumentIsUnique = false;
            this.showIdDocumentIsUniqueError = true;
            reject(this.idDocumentIsUnique);
          });
      });
    },
    getLocationPackage() {
      const locationSelected = this.locationOptions.find(
        (element) => element._id == this.location
      );

      this.$emit(
        "requestPackages",
        true,
        [],
        locationSelected.nombre,
        locationSelected.key,
        locationSelected.codigo,
        locationSelected.TID,
        locationSelected.MID
      );
      const bodyFormData = new FormData();
      bodyFormData.append("sede", this.location);

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/1.1/wf/get-paquetes`,
          bodyFormData,
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_TOKEN}`,
            },
          }
        )
        .then((response) => {
          this.$emit(
            "requestPackages",
            false,
            response.data.response.paquetes,
            locationSelected.nombre,
            locationSelected.key,
            locationSelected.codigo
          );
        })
        .catch(() => {
          this.$emit(
            "requestPackages",
            true,
            [],
            locationSelected.nombre,
            locationSelected.key,
            locationSelected.codigo
          );
        });
    },
  },
  mounted() {
    const payload = this.buildGetSedesPayload();

    axios
      .post(`${process.env.VUE_APP_API_URL}/api/1.1/wf/get-sedes`, payload, {
        headers: {
          Authorization: `Bearer ${process.env.VUE_APP_TOKEN}`,
        },
      })
      .then((response) => {
        this.locationOptions = response.data.response.sedes || [];

        if (this.preSaleMode) {
          if (this.locationOptions.length > 0) {
            this.location = this.locationOptions[0]._id;
          } else {
            this.redirectPreSaleLocationNotFound();
          }
        }
      })
      .catch(() => {
        this.locationOptions = [];

        if (this.preSaleMode) {
          this.redirectPreSaleLocationNotFound();
        }
      });
  },
  watch: {
    location() {
      if (this.location) this.getLocationPackage();
    },
    state() {
      if (this.state) this.city = "";
      this.cityOptions = this.stateOptions.find(
        (state) => state.title == this.state
      ).cities;
    },
    city() {
      if (this.city) {
        this.zone = "";
        if (
          this.city == "Guatemala" ||
          this.city == "Mixco" ||
          this.city == "Villa Nueva"
        ) {
          this.requiredZone = true;
        } else {
          this.requiredZone = false;
        }
      }
    },
    idDocument() {
      this.showIdDocumentIsUniqueError = false;
      this.idDocumentIsUnique = true;
    },
    checkBox3(val) {
      if (val) {
        //open a dialog or modal with terms and conditions pdf embedded
        this.$modal.show("modal-terms");
        //if modal is opened disable windows scroll but
      }
    },
    firstName(val) {
      //val dont have special characters and numbers
      this.firstName = val.replace(/[^a-zA-Z ]/g, "");
    },
    surName1(val) {
      //val dont have special characters and numbers
      this.surName1 = val.replace(/[^a-zA-Z ]/g, "");
    },
    surName2(val) {
      //val dont have special characters and numbers
      this.surName2 = val.replace(/[^a-zA-Z ]/g, "");
    },
  },
  created() {
    window.addEventListener("message", (event) => {
      if (event.data === "acceptEvent") {
        this.$modal.hide("modal-terms");
      }
      if (event.data === "cancelEvent") {
        this.cancelTermsAndConditions();
      }
    });
  },
};

//I have a button with a class
</script>

<style>
/* .vm--modal {
  overflow-y: auto !important;
} */

#signature-pad {
  box-shadow: none !important;
}
</style>
